export enum MsgEnum {
  ClientInfo = 'ClientInfo',
  CreateRoom = 'CreateRoom',
  JoinRoom = 'JoinRoom',
  ExitRoom = 'ExitRoom',
  Kick = 'Kick',
  CloseRoom = "CloseRoom",
  ClientReady = 'ClientReady',
  RoomStart = 'RoomStart',
  ListRooms = "ListRooms",
  Error = "Error",
  Chat = "Chat",
  Tick = "Tick",
  KeyTick = "KeyTick",
  RoomPwd = "RoomPwd",
  RoomSync = 'RoomSync',
  Ping = "Ping",
  Dataset = 'Dataset',

  // for admin.
  ListClients = 'ListClients',
}
